export const mainClass = 'card-circular'
export const DEFAULT_LEVEL = 'LEVEL'
export const CIRCLE_CENTER = 50
export const CIRCLE_RADIUS = 45
export const CIRCLE_ROTATION_OFFSET = -144
export const STROKE_WIDTH = 8
export const ANIMATION_DURATION = 2000
export const ANIMATION_STEPS = 60
